import moment from "moment"
import TablePage from "../../../../../components/pages/TablePage"

export default () => {
    const columns = [
        {
            selector: (row) => row?.description,
            name: "Description",
            id: 'description'
        },
        {
            selector: (row) => row?.user_id?.name,
            name: "User",
            id: 'user_id'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "CreatedAt",
            id: 'createdAt'
        },
    ]
    return (
        <TablePage
            title={"RKSP Log"}
            url="api/v1/rksp_log"
            actionPosition={'first'}
            columns={columns}
        />
    )
}